<template>
    <modal id="new-tigard-modal" divider hide-footer hide-header>
        <div class="hero-img">
            <primary-link class="position-relative link">
                <i aria-hidden="true" class="close-icon material-icons" @click="closeModal"> close </i>
            </primary-link>
        </div>
        <div class="body-section">
            <div class="header">
                <p class="text-center title">New Name, New Facility, Same Great Team</p>
                <hr class="divider" />
            </div>
            <div class="body-content">
                <p class="text text-center">Kuni BMW is now <b>BMW of Tigard</b> .</p>
                <p class="text text-center mt-4">
                    Please come visit us at our new state-of-the-art dealership located at
                    <b>10035 SW Cascade Ave, Tigard, OR 97223</b>
                </p>
            </div>
        </div>
        <div class="d-flex flex-column footer-section">
            <div class="w-100">
                <primary-btn class="shop-btn w-100" @click.native="handleBtnClick">
                    Shop for your next BMW
                </primary-btn>
            </div>
        </div>
    </modal>
</template>

<script>
import Modal from "Components/Modal.vue";
import PrimaryLink from "Components/Links/primaryLink.vue";
import PrimaryBtn from "Components/Buttons/PrimaryBtn.vue";
import MfaRedirectionMixin from "Modules/Home/components/Home/MfaRedirectionMixin.vue";

export default {
    name: "NewTigardModal",
    components: {
        PrimaryBtn,
        Modal,
        PrimaryLink,
    },
    mixins: [MfaRedirectionMixin],
    methods: {
        closeModal() {
            console.log(this.$route.path);
            this.$bvModal.hide("new-tigard-modal");
        },
        handleBtnClick() {
            if (this.$route.path === "/listings") {
                this.closeModal();
            } else {
                const filters = { stockTypeConditions: ["NEW"] };
                this._mixin_handleRedirectionsWithFilters(filters);
            }
        },
    },
};
</script>

<style lang="scss">
#new-tigard-modal {
    .modal-dialog {
        margin: 8.75rem auto !important;
        @include media-breakpoint-down(sm) {
            margin: 90px 16px 0 16px !important;
        }
        .modal-content {
            padding: 0 !important;

            .modal-body {
                padding: 0 !important;
            }
        }
    }

    .body-section {
        padding: 22px 30px 32px 30px;
        @include media-breakpoint-down(sm) {
            padding: 16px 28px 16px 28px;
        }
        .header {
            .title {
                color: $secondary-gray;
                font-size: px2rem(28);
                margin-bottom: px2rem(8) !important;
                @include media-breakpoint-down(sm) {
                    font-size: px2rem(26);
                }
            }
            .sub-title {
                margin-top: 8px;
                font-size: px2rem(15);
                color: $primary-gray;
                @include media-breakpoint-down(sm) {
                    font-size: px2rem(14);
                }
            }
        }
        .body-content {
            margin-top: px2rem(34);
            display: flex;
            flex-direction: column;
            gap: 24px;
            @include media-breakpoint-down(sm) {
                margin-top: px2rem(26);
                gap: 16px;
            }
        }
        .divider {
            width: 178px;
            height: 2px;
            margin-top: px2rem(18);
            @include themify($themes) {
                background-color: themed("primary-color");
            }
        }
        p {
            margin: 0 !important;
        }
        .text {
            font-size: px2rem(16);
            color: $primary-gray;
        }
    }

    .footer-section {
        padding: 0 30px 30px 30px;
        @include media-breakpoint-down(sm) {
            padding: 0 16px 16px 16px;
        }

        .shop-btn {
            padding: 12px;
            font-size: px2rem(16);
            font-style: normal;
            font-weight: 700;
            line-height: normal;
            @include media-breakpoint-down(sm) {
                font-size: px2rem(16);
            }
        }
    }

    .hero-img {
        position: relative;
        width: 100%;
        height: 300px;
        background-size: cover;
        background-repeat: no-repeat;
        @include media-breakpoint-down(sm) {
            height: 240px;
        }
        @include themify($themes) {
            background-image: themed("new-name-change-banner-lg");
            @include media-breakpoint-down(sm) {
                background-image: themed("new-name-change-banner-md");
            }
        }
    }

    .link {
        z-index: 3;
        top: 10px;
        right: 10px;
        position: absolute !important;
    }

    .hero-img:after {
        top: 0;
        left: 0;
        z-index: 2;
    }

    .modal {
        overflow: hidden !important;
    }

    .close-icon {
        color: $black;
    }
}
</style>
